import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as Import from 'import/components';

import { headers } from 'import/constants';
// import assetsFile from 'assets/plantilla-importar.csv' // assets
// import costCenterFile from 'assets/cost-center-import.csv' // cost-center
// import providersFile from 'assets/providers-import.csv' // providers
// import proyectsFile from 'assets/proyects-import.csv' // proyects

import { setFile, removeFile, uploadFile, importFile, reset, modify } from 'import/actions';
import { getCustomFieldsEmployees } from 'employees/actions';

import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getFile,
  getIsImporting,
  getModule,
  getHeaders,
  getHeadersSelect,
  getHeadersOpciones,
} from 'import/selectors';
import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors';

import { valueFromEvent, createRoute } from 'lib/util';
import { mapImportHeaders } from 'lib/import/map_import_headers';

class ImportFormContainer extends PureComponent {
  componentWillMount = async () => {
    await this.props.reset();
    await this.props.modify({ headersSelect: null });
  };

  componentDidMount = async () => {
    if (this.props.location && this.props.location.state && this.props.location.state.file) {
      await this.props.modify({ module: this.props.location.state.module });
      this.checkHeaders(this.props.location.state.file);
    }
  };

  handleValueChange = (e, inicial) => {
    this.props.modify(valueFromEvent(e));
    if (this.props.headersSelect && !inicial) {
      //Revisar si ya se analizaron los headers en alguna ocacion.
      this.checkHeaders(null);
    }
  }; // Normal para input

  readFile = async (file) => {
    var reader = new FileReader();
    reader.onload = function (e) {
      reader.result;
    };
    reader.readAsText(file);
    return reader.onloadend();
  };

  readFileAsText = (inputFile) => {
    const temporaryFileReader = new FileReader();

    return new Promise((resolve, reject) => {
      temporaryFileReader.onerror = () => {
        temporaryFileReader.abort();
        reject(new DOMException('Problem parsing input file.'));
      };

      temporaryFileReader.onload = () => {
        resolve(temporaryFileReader.result);
      };
      temporaryFileReader.readAsText(inputFile);
    });
  };

  csvJSONheaders(csv) {
    // Obtiene los headers de un blob de csv
    var lines = csv.split('\n');
    var headers = lines[0].split(',');
    headers.forEach((key, index) => {
      headers[index] = key.replace('\r', '');
    });
    return headers;
  }

  csvJSON(csv) {
    // transforma el blob de un csv a JSON
    var lines = csv.split('\n');
    var result = [];
    var headers = lines[0].split(',');
    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(',');
      for (var j = 0; j < headers.length; j++) {
        headers[j] = headers[j].replace('\r', '');
        obj[headers[j]] = currentline[j];
      }
      result.push(obj);
    }
    return result; //JavaScript object
    // return JSON.stringify(result); //JSON
  }

  checkHeaders = async (blob) => {
    console.log(this.props.module);
    let headersModule = JSON.parse(JSON.stringify(headers));

    const dinamicos = ['cuenta_contable', 'tipo_activo', 'custom_employees'];
    let esDinamico = dinamicos.indexOf(this.props.module) > -1;

    let dataJSON = null;
    let headersJSON = null;

    if (blob != null) {
      // en caso de usar Re-Import, obteniendo el blob directo del url
      dataJSON = this.csvJSON(blob);
      headersJSON = this.csvJSONheaders(blob); // Headers del csv
    } else {
      const result = await this.readFileAsText(this.props.file.file); // Leer archivo csv
      dataJSON = this.csvJSON(result);
      headersJSON = this.csvJSONheaders(result); // Headers del csv
    }

    if (this.props.module == 'employees') {
      // Se agregan los custom fields por empleados
      await this.props.getCustomFieldsEmployees(this.props.company.id, this.props.subcompany.id);
      this.props.customfields.forEach((custom) => {
        headersModule[this.props.module].push(custom.name);
      });
    }

    // Unmatched columns are `sin_asignar_N` and a missing expected column has
    // posicion UNASSIGNED (lib/import/map_import_headers.js).
    const { headers: headersAEntregar, headersSelect, headersOpciones } = mapImportHeaders(
      headersModule[this.props.module],
      headersJSON,
      esDinamico
    );

    this.props.modify({ headers: headersAEntregar, headersSelect, headersOpciones }); // Headers a entregar a backend
  };

  handleFileRemove = () => {
    this.props.removeFile();
    this.props.modify({ headersSelect: null });
  };

  handleHeaderChange = (select, e) => {
    const { name, value } = e.target;
    let nuevoHeaders = JSON.parse(JSON.stringify(this.props.headers));
    let nuevoSelect = JSON.parse(JSON.stringify(this.props.headersSelect));

    nuevoHeaders[value] = select.key;
    nuevoSelect[name].posicion = Number(value);

    this.props.modify({ headers: nuevoHeaders, headersSelect: nuevoSelect });
  };

  handleFileSelected = (files) => {
    // Maneja la seleccion de archivo
    if (Array.isArray(files) && files.length == 0) {
      this.props.error('import.error.fileType');
    } else {
      this.props.setFile(files.pop());
      this.checkHeaders(null);
    }
  };

  handleSubmit = async ({ isValid }) => {
    try {
      let urlUsar = null;

      if (this.props.location && this.props.location.state && this.props.location.state.urlCSV) {
        // En caso de reimportar
        urlUsar = this.props.location.state.urlCSV;
      } else {
        // Al importar normalmente
        if (!isValid) return this.props.error('import.error.verify');
        const {
          value: {
            files: [file],
          },
        } = await this.props.uploadFile(
          this.props.file,
          this.props.company.id,
          this.props.subcompany.id
        );
        urlUsar = file.url;
      }

      const {
        value: { message },
      } = await this.props.importFile(this.props.company.id, this.props.subcompany.id, {
        url: urlUsar,
        modul: this.props.module,
        colums: this.props.headers,
      });
      this.props.success(message);
      this.props.location.state = {};
      this.props.reset();
      this.props.history.push(
        createRoute(this.props.company.id, this.props.subcompany.id, 'import')
      );
    } catch (e) {
      console.log(e);
      return this.props.error('import.error.importing');
    }
  };

  render = () => {
    // console.log(this.props.location.state);
    // console.log(this.props.module);
    // console.log(this.props.customfields);
    return (
      <Import.FormView
        company={this.props.company}
        file={this.props.file}
        headersOpciones={this.props.headersOpciones}
        headersSelect={this.props.headersSelect}
        module={this.props.module}
        isImporting={this.props.isImporting}
        handleFileSelected={this.handleFileSelected}
        handleFileRemove={this.handleFileRemove}
        handleSubmit={this.handleSubmit}
        handleValueChange={this.handleValueChange}
        handleHeaderChange={this.handleHeaderChange}
        subcompany={this.props.subcompany}
      />
    );
  };
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  file: getFile(state),
  module: getModule(state),
  isImporting: getIsImporting(state),
  permissions: getPermissions(state),
  subcompany: getSubcompany(state),
  headers: getHeaders(state),
  headersOpciones: getHeadersOpciones(state),
  headersSelect: getHeadersSelect(state),
  customfields: getVisibleCustomFieldsEmployees(state),
});

const mapDispatchToProps = {
  setFile,
  removeFile,
  uploadFile,
  importFile,
  error,
  success,
  reset,
  modify,
  getCustomFieldsEmployees,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ImportFormContainer));



// WEBPACK FOOTER //
// src/modules/secured/modules/import/containers/ImportFormContainer.js